import { db } from "../Config";

const getDiagnosticosCollection = (pacienteId, empresaId) => {
    return db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("diagnosticos");
};

export const crearDiagnostico = async (pacienteId, empresaId, diagnostico) => {
    const docRef = getDiagnosticosCollection(pacienteId, empresaId).doc();
    const data = {
        ...diagnostico,
        id: docRef.id,
        fecha: new Date(),
        estado: "PENDIENTE" // PENDIENTE de planificar
    };
    await docRef.set(data);
    return data;
};

export const fetchDiagnosticosByPaciente = async (pacienteId, empresaId) => {
    const snapshot = await getDiagnosticosCollection(pacienteId, empresaId)
        .where("estado", "==", "PENDIENTE")
        .get();

    return snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
};

export const marcarDiagnosticoPlanificado = async (pacienteId, empresaId, diagnosticoId, prestacionId) => {
    await getDiagnosticosCollection(pacienteId, empresaId).doc(diagnosticoId).update({
        estado: "PLANIFICADO",
        prestacionId: prestacionId
    });
};
